import { Spinner } from '@flipster/ui';

import styles from '../tpslModal.module.scss';

const LoadingSpinner = () => {
  return <Spinner className={styles.spinner} center />;
};

export default LoadingSpinner;
